import { useContext } from 'react'
import { ProductCatalogContext } from './ProductCatalogProvider'

export function useProductCatalog() {
  const productCatalogContext = useContext(ProductCatalogContext)

  if (!productCatalogContext) throw new Error('ProductCatalogContext has to be used within <ProductCatalogContext.Provider>')

  return productCatalogContext
}
